// Host destinations the consumer home links to, in one place, so a host route change is a single edit
// here. Callers are the step catalogue (`plan-steps.tsx`) and the sidebar's "Send a message".
//
// Still no constant for `/appointments`, but no longer for CONAPP-293's reason — that page is real
// since MEM-855. Nothing in this package links there: the Appointments tile moved to
// `@internal/telemedicine` (MEM-856) and the host injects its routes from the `Paths` enum.
//
// Literal paths rather than the host's `Paths` enum: the package can't import from `#/` (one-way
// dependency — see packages/consumer/README.md).

// The sidebar's "Send a message" only, since CONAPP-192: CONAPP-234's archetype → action map has
// no Care Team step, so no card links here any more.
export const MESSAGES_PATH = "/messages"
export const TELEMEDICINE_PATH = "/telemedicine"
// The Academy library ROOT, and since CONAPP-296 a base rather than a destination: the 26 Academy
// steps each build their own per-resource path from it (`plan-steps.tsx`'s `academyArticle` /
// `academyGuide` / `academySubcategory`). No card points at the bare root any more.
//
// ⚠ Keep it the only `/read` prefix in this file. `PlanStepSourceLabel` decides whether to draw the
// "Carrot Academy" label by testing a step's destination against it with `startsWith`, so a
// non-Academy destination added under `/read` would start claiming to be Academy content.
export const CARROT_ACADEMY_PATH = "/read"
// The host's "Find care and services" nav item (`ProviderFinderNavItem` → `Paths.PROVIDER_FINDER`).
export const FIND_CARE_PATH = "/provider-finder"
export const CARROT_RX_PATH = "/carrot-rx"
// Where the four at-home test steps send members (`Paths.EXCLUSIVE_DISCOUNTS`). The tests are sold
// through the Carrot Collective rather than linked directly: each vendor's CTA is a dynamic POST
// built from Contentful, so there is no static vendor URL for a step to point at.
export const EXCLUSIVE_DISCOUNTS_PATH = "/exclusive-discounts"
